import React from 'react';

import Button from 'shared/button';
import { buildGrantUrl } from './helpers';

interface Props {
  path: string;
  scopes?: string[];
}

export default function NewNylasGrant({ path, scopes }: Props) {
  return (
    <Button.Primary
      label="Connect"
      onClick={() => window.location.assign(buildGrantUrl(path, scopes))}
    />
  );
}
